import { TicketPurchaseIntentDto } from '@cineamo/api/models/ticket-purchase-intent/TicketPurchaseIntentDto';
import { TicketPurchaseIntentInputDto } from '@cineamo/api/models/ticket-purchase-intent/TicketPurchaseIntentInputDto.types';

import { ApiErrorResponse } from '@cineamo/api/types/ApiErrorResponse.types';
import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

import { API_URL } from '@/constants/http-constants';

import apiClient from '@/utils/api/cineamoApiClient';

/**
 * This endpoint creates a Ticket Purchase Intent Dto.
 *
 * @example
 * createTicketPurchaseIntent({...data});
 *
 * @param data
 * @returns {ApiResponse<TicketPurchaseIntentDto> | ApiErrorResponse<TicketPurchaseIntentInputDto>}
 */

export async function createTicketPurchaseIntent(
    data: TicketPurchaseIntentInputDto
): Promise<ApiResponse<TicketPurchaseIntentDto> | ApiErrorResponse<TicketPurchaseIntentInputDto>> {
    return await apiClient
        .post(`${API_URL}/ticket-purchase-intents`, data)
        .then((res) => res)
        .catch((error) => error);
}
